<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="find-ad-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                    </button>

                    <h4 class="modal-title">
                        Find DTP Info
                    </h4>
                </div>

                <div class="modal-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <th class="col-xs-20">
                                    Ad
                                </th>

                                <th class="col-xs-4"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="ad in ads.data">
                                <td>
                                    {{ ad.name }}

                                    <div class="pull-right">
                                        <i v-if="ad.url" class="fa fa-link" v-tooltip="ad.url"></i>

                                        <i v-else class="fa fa-link" style="opacity: 0.2"></i>

                                        <i v-if="ad.content" class="fa fa-image" v-tooltip="ad.content"></i>

                                        <i v-else class="fa fa-image" style="opacity: 0.2"></i>

                                        <i v-if="ad.dtp_comment" class="fa fa-comment" v-tooltip="ad.dtp_comment"></i>

                                        <i v-else class="fa fa-comment" style="opacity: 0.2"></i>
                                    </div>
                                </td>

                                <td class="text-right">
                                    <button type="button" class="btn btn-xs btn-black" @click="select(ad)">
                                        <i class="fa fa-check"></i> Select
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ads'],
        
        methods: {
            select(ad) {
                this.$emit('select', ad)

                $('#find-ad-modal').modal('hide')
            }
        }
    }
</script>

<style>
    #find-ad-modal .modal-body {
        max-height: 400px;
        overflow-y: scroll;
    }
</style>
